import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import backend from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';
import Cookies from 'js-cookie';
// ----------------------------------------------------------------------

const apiLanguage = Cookies.get('django_language');

i18n
  .use(LanguageDetector)
  .use(backend)
  .use(initReactI18next)
  .init({
    lng: apiLanguage || 'en',
    fallbackLng: 'en',
    debug: false,
    ns: ['translations'],
    defaultNS: 'translations',
    interpolation: {
      escapeValue: false
    },
    backend: {
      loadPath: '/static/locales/{{lng}}/{{ns}}.json'
    },
    react: {
      useSuspense: false,
      wait: true
    }
  });

export default i18n;
